import { createFileRoute } from '@tanstack/react-router';
import * as z from 'zod';

const searchSchema = z.object({
  carpetId: z.string().optional(),
});

export const Route = createFileRoute(
  '/_authenticated/(payment-methods)/cards/create/',
)({
  validateSearch: searchSchema,
});
